import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
export default function UserToggleActive (params: {user: any, setUser: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setUser(null);
    };

    const handleUpdateActive= async () => {
        setLoading(true);
        const query = gql`
            mutation m($id: Int!, $active: Boolean!) {
                userUpdateActive(id: $id, active: $active)
            }
        `;

        const variables = {
            id: params.user.id,
            active: !params.user.active,
        }

        const response = await mutate(query, variables);
        if (response && response.userUpdateActive) {
            toast.success(<><Box component={"span"}
                                 sx={{fontWeight: "bold"}}>{params.user.name} ({params.user.id})</Box> has been updated
                to <Box
                    component={"span"}
                    sx={{fontWeight: "bold"}}>{params.user.active ? "Inactive" : "Active"}</Box></>);
            handleClose();
            params.reload();
        }
        setLoading(false);

    }

    if (!params.user) return <> </>;

    return (
        <>

                <Dialog
                    open={!!params.user}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to set <Box component={"span"}
                                                                  sx={{fontWeight: "bold"}}>{params.user.name} ({params.user.id})</Box> to <Box
                            component={"span"}
                            sx={{fontWeight: "bold"}}>{params.user.active ? "Inactive" : "Active"}</Box>?
                        </DialogContentText>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>No</Button>
                        <Button sx={{color: 'green'}} onClick={handleUpdateActive} autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
